import { useId } from "react";

interface CheckboxFieldProps {
  label: string;
  checked: boolean;
  onChange: (checked: boolean) => void;
  helper?: React.ReactNode;
  disabled?: boolean;
}

export function CheckboxField({
  label,
  checked,
  onChange,
  helper,
  disabled,
}: CheckboxFieldProps) {
  const id = useId();
  return (
    <div style={{ display: "grid", gap: 6 }}>
      <label
        htmlFor={id}
        style={{
          display: "flex",
          alignItems: "center",
          gap: 8,
          fontSize: "0.9rem",
          color: "var(--text)",
        }}
      >
        <input
          id={id}
          type="checkbox"
          checked={checked}
          disabled={disabled}
          onChange={(e) => onChange(e.target.checked)}
        />
        {label}
      </label>
      {helper && (
        <span style={{ fontSize: "0.75rem", color: "var(--text-dim)" }}>
          {helper}
        </span>
      )}
    </div>
  );
}
